<script setup lang="ts">
import {CirclePlus, Edit, View} from "@element-plus/icons-vue";
import {getQuestionType, getTimeStr} from "@/utils/common.ts";
import {TestQuestionInfo} from "@/types";
import router from "@/router";
import {nextTick, ref, watch} from "vue";

const problemTitle = ref()

const props = defineProps<{
  testQuestionInfo: TestQuestionInfo | undefined
}>()

const emit = defineEmits<{
  (e: 'onEditQuestion'): void
  (e: 'onAddSubQuestion'): void
}>()

const seeReelInfo = () => {
  const routeData = router.resolve({
    path: "/creator/test/list",
    query: {
      reel_id: props.testQuestionInfo?.reel_id
    }
  })
  window.open(routeData.href, '_blank')
}

const onEditQuestion = () => {
  emit('onEditQuestion')
}

const onAddSubQuestion = () => {
  emit('onAddSubQuestion')
}

watch(
    () => props.testQuestionInfo?.problem,
    (_) => {
      nextTick(() => {
        if (problemTitle.value) {
          renderMathInElement(problemTitle.value)
        }
      })
    }
)
</script>

<template>
  <!-- 大题 -->
  <el-descriptions border v-if="testQuestionInfo" :column="3">
    <el-descriptions-item label="ID" :span="1">{{ testQuestionInfo.id }}</el-descriptions-item>
    <el-descriptions-item
        :span="2"
        label="题目类型">
      {{
        getQuestionType(testQuestionInfo.type)
      }}
    </el-descriptions-item>
    <el-descriptions-item label="标题" :span="3">
      <div ref="problemTitle" class="whitespace-pre-wrap">
        {{ testQuestionInfo.problem }}
      </div>
    </el-descriptions-item>
    <el-descriptions-item
        :span="3"
        label="题目图片"
        v-if="testQuestionInfo.image"
    >
      <el-image
          style="width: 7.5rem; height: 7.5rem"
          :src="item"
          :zoom-rate="1.2"
          :max-scale="7"
          :min-scale="0.2"
          :preview-src-list="testQuestionInfo.image.split(',')"
          :initial-index="index"
          fit="cover"
          class="mr-1rem rounded"
          v-for="(item, index) in testQuestionInfo.image.split(',')"
      />
    </el-descriptions-item>
    <el-descriptions-item
        :span="3"
        label="选项"
        v-if="(testQuestionInfo.type === 1 || testQuestionInfo.type === 2 || testQuestionInfo.type === 5) && testQuestionInfo.answer">
      <template v-for="(item,index) in testQuestionInfo.answer">
        <div class="bg-#f6f7f9 px-.5rem my-.5rem border-#D9D9D9 border-dashed border-.5px">
          {{ `${String.fromCharCode(index + 65)}、${item}` }}
        </div>
      </template>
    </el-descriptions-item>
    <el-descriptions-item :span="3" label="正确答案" v-if="testQuestionInfo.type != 0">
      {{ testQuestionInfo.right_answer }}
    </el-descriptions-item>
    <el-descriptions-item :span="3" label="解析"  v-if="testQuestionInfo.type != 0">
      {{ testQuestionInfo.parsing || `暂无解析~` }}
    </el-descriptions-item>
    <el-descriptions-item
        :span="3"
        label="答案图片"
        v-if="testQuestionInfo.right_answer_image"
    >
      <el-image
          style="width: 7.5rem; height: 7.5rem"
          :src="item"
          :zoom-rate="1.2"
          :max-scale="7"
          :min-scale="0.2"
          :preview-src-list="testQuestionInfo.right_answer_image.split(',')"
          :initial-index="index"
          fit="cover"
          class="mr-1rem rounded"
          v-for="(item, index) in testQuestionInfo.right_answer_image.split(',')"
      />
    </el-descriptions-item>
    <el-descriptions-item
        label="一级分类"
        v-if="testQuestionInfo.f_cate_name"
    >
      {{ testQuestionInfo.f_cate_name }}
    </el-descriptions-item>
    <el-descriptions-item
        label="二级分类"
        v-if="testQuestionInfo.s_cate_name"
    >
      {{ testQuestionInfo.s_cate_name }}

    </el-descriptions-item>
    <el-descriptions-item
        label="关联套卷"
        v-if="testQuestionInfo.reel_id"
    >
      {{ testQuestionInfo.reel_name }}
      <el-button :icon="View" size="small" @click="seeReelInfo">
        点击查看
      </el-button>
    </el-descriptions-item>
    <el-descriptions-item
        label="创建时间"
        v-if="testQuestionInfo.create_time"
    >
      {{ getTimeStr(testQuestionInfo.create_time * 1000) }}
    </el-descriptions-item>
    <el-descriptions-item
      label="操作">
      <el-button type="primary" :icon="Edit" @click="onEditQuestion">编辑</el-button>
      <el-button type="primary" :icon="CirclePlus" @click="onAddSubQuestion" v-if="testQuestionInfo.type === 0">添加小题</el-button>
    </el-descriptions-item>
  </el-descriptions>
</template>

<style scoped>
</style>
